import * as React from 'react';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const separatorVariants = cva('rocco-skeleton', {
    variants: {
        variant: {
            default: 'animate-pulse rounded-md bg-muted',
            light: 'animate-pulse rounded-md bg-gray-200',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const Skeleton = ({
    className,
    variant,
    ...props
}: React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof separatorVariants>) => (
    <div className={cn(separatorVariants({ variant }), className)} {...props} />
);

Skeleton.displayName = 'Skeleton';
